import type { FaireProductEntity } from "../../entity_types/product";

export const p_9g42vvugad: FaireProductEntity = {
  token: "p_9g42vvugad",
  type: "product",
  name: "LE GRAND SAINT SAUVEUR",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/2edb7f9c0674d1818bf9db6015c4676ab50c4bb149ef0bdc8953a227946a21ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24e41864aa185f867fac1a33907aab21f764d3d9d993ad01694728a821b1ed10.jpeg"
  ],
  priceDollars: 30,
  description: "Le Grand Saint Sauveur, 14 oz of your favorite scent!\n\nSmoky late night walks along the meandering street of Rue Saint-Sauveur. Hidden corners, whispered secrets and the ever present feeling of endless possibilities. This scent embodies the spirit of those magical moments with velvety notes of cashmere wood, sweet tobacco, and a delicate hint of smoke.\n\n• sweet tobacco\n• rum\n• cashmere wood\n• smoke\n• ambrette\n\n• Roen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.\n• We use lead-free cotton wicks and premium fragrance oils.\n• All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n14 ounces (397g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:10.126Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
